import { Injectable } from '@angular/core';
import {ApiService} from '../../../../core/service/api.service';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class CampaignPrefixConfigService {

  constructor(private api: ApiService) {
  }

  getPrefixConfigs(pkCamp: number): Observable<any> {
    return this.api.get('vna/campaign/' + pkCamp + '/prefix-configs');
  }

  postPrefixConfig(pkCamp: number, data: Object): Observable<any> {
    return this.api.post('vna/campaign/' + pkCamp + '/prefix-config', data);
  }

  putPrefixConfig(pkCamp: number, pkPrefix: number, data: Object): Observable<any> {
    return this.api.customPut('vna/campaign/prefix-config/' + pkPrefix, data);
  }

  removePrefixConfig(pkPrefix: number): Observable<any> {
    return this.api.customRemove('vna/campaign/prefix-config/' + pkPrefix);
  }

}





// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/services/campaign-prefix-config.service.ts